// @flow

import React from 'react';
import { Message } from 'semantic-ui-react';
import QuestionItem from './QuestionItem';
import type { Question, QuestionType } from '../../types';

type Props = {
  questions: Array<Question>,
  showValidationErrors: boolean,
  onUpdateQuestion: (question: Question) => void,
  onChangeQuestionOrder: (question: Question, order: number) => void,
  onChangeQuestionType: (question: Question, type: QuestionType) => void,
  onDeleteQuestion: (question: Question) => void,
};

const QuestionsList = ({
  questions,
  showValidationErrors,
  onUpdateQuestion,
  onChangeQuestionOrder,
  onChangeQuestionType,
  onDeleteQuestion,
}: Props) => {
  if (questions.length === 0) {
    return <Message attached="bottom" icon="info" header="Aucune question" />;
  } else {
    return (
      <div>
        {questions.map(question => (
          <QuestionItem
            key={question.id}
            question={question}
            showValidationErrors={showValidationErrors}
            questionsCount={questions.length}
            onUpdate={onUpdateQuestion}
            onChangeOrder={onChangeQuestionOrder}
            onChangeType={onChangeQuestionType}
            onDelete={onDeleteQuestion}
          />
        ))}
      </div>
    );
  }
};

export default QuestionsList;



// WEBPACK FOOTER //
// ./src/modules/survey/components/questions/QuestionsList.js